import { useState } from "react"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { fromInputDate, toInputDate } from "../../Objects/Generics/Helps"
import { NoticeEntity } from "../../Objects/Notice/NoticeEntity"


export const useCreateNotice = () => {
  const [notice, setNotice] = useState<NoticeEntity | null>(null)

  const [name, setName] = useState("")

  const [description, setDescription] = useState("")

  const [status, setStatus] = useState<EEnableStatusType>(EEnableStatusType.Active)

  const [startDate, setStartDate] = useState<string>(toInputDate(new Date()))

  const [endDate, setEndDate] = useState<string>(toInputDate(new Date()))

  const handleInitialValue = (noticeData?: NoticeEntity) => {
    if (!noticeData) {
      return
    }

    setNotice(noticeData)

    setName(noticeData.name)

    setDescription(noticeData.description)

    setStatus(noticeData.status)

    setStartDate(toInputDate(noticeData.startDate))

    setEndDate(toInputDate(noticeData.endDate))
  }

  const handleSubmitForm = () =>
    new NoticeEntity({
      id: notice?.id,
      name,
      description,
      status,
      startDate: fromInputDate(startDate),
      endDate: fromInputDate(endDate),
      iconUrl: notice?.iconUrl,
    })

  return {
    name,
    description,
    status,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    handleInitialValue,
    handleSubmitForm,
    handleNameChange: (e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value),
    handleDescriptionChange: (e: React.ChangeEvent<HTMLInputElement>) => setDescription(e.target.value),
    handleStatusChange: (e: React.ChangeEvent<HTMLSelectElement>) =>
      setStatus(e.target.selectedIndex as EEnableStatusType),
  }
}
